import { ONE_MINUTE_IN_SECONDS } from '@/constants'
import { unstable_cache } from 'next/cache'

export type CacheOptions = {
  ttl?: number
  tag?: string
}

export function rmwPrismaCache() {
  return {
    name: 'rmwPrismaCache',
    model: {
      $allModels: {
        withCache(this: any, cacheOptions?: CacheOptions) {
          const { ttl, tag } = cacheOptions || {}
          const modelName = this.$name

          return new Proxy(this, {
            get(target, prop, receiver) {
              const originalMethod = Reflect.get(target, prop, receiver)
              if (typeof originalMethod !== 'function') return originalMethod

              return async function (...args: any[]) {
                const key = `__rmwPrismaCache-${modelName}-${String(
                  prop
                )}-${JSON.stringify(args)}`
                const tags = tag ? [tag] : []

                const cachedFn = unstable_cache(
                  () => originalMethod.apply(target, args),
                  [key],
                  {
                    revalidate: ttl || ONE_MINUTE_IN_SECONDS * 5,
                    tags,
                  }
                )

                return cachedFn()
              }
            },
          })
        },
      },
    },
  }
}
